import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import RichText from "../components/RichText";

import video from "../assets/videos/ecotuningvideo.mp4";
import imageurl1 from "../assets/images/eco1.png";
import video2 from "../assets/videos/service2.mp4";

function ECOTuning() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Bij Eco Tuning wordt de motor van uw voertuig fijn afgesteld. Er zal
        hierdoor een betere verbranding in de motor plaatsvinden. Het voertuig
        maakt dan efficiënter gebruik van de brandstof en zal leiden tot een
        lager verbruik.
      </p>
    </>
  );

  const text2 = (
    <>
      <h3 className="text-white text-xl text-left">
        Watis het verschil tussen Eco tuning en Chiptuning stage 1?
      </h3>
      <br />
      <p className="text-white text-lg text-left">
        In beide gevallen wordt de software van de auto volledig
        geoptimaliseerd. Waar bij de chiptuning stage 1 de focus wordt gelegd om
        meer vermogen uit de auto te halen, wordt er bij eco tuning juist
        gekeken om het maximale rendement uit de brandstof te halen. Bij
        chiptuning stage 1 is er ook sprake van brandstofbesparing, echter is
        dit bij eco tuning ook echt het doel. Bij chiptuning stage 1 worden
        zowel het vermogen en koppel geoptimaliseerd en softwarematig
        herprogrammeerd. Bij chiptuning stage 1 wordt dan ook het maximale
        vermogen uit de auto gehaald. Bij eco tuning wordt alleen het koppel
        geoptimaliseerd en softwarematige hergeprogrammeerd. Door alleen het
        koppel te verhogen maakt de auto een lagere rpm mogelijk, dit leidt
        vervolgens tot een aanzienlijke brandstofbesparing. Doordat er een
        efficiëntere verbranding plaatsvindt en het koppel verhoogd wordt, kan
        het vermogen van de auto ook toenemen. Bij X-TREMETUNINGS bieden wij de
        service om de Eco Tuning te programmeren in de ECU van uwvoertuig.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="ECO TUNING" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />

      <RichText text={text2} bordered="true" />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default ECOTuning;
